import { alpha, makeStyles } from "@material-ui/core/styles";
import { Colors } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({
  borderBottom: {
    borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
    "& .box-shadow": {
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,
    },
  },
  hideArrow: {
    '& .MuiAccordionSummary-expandIcon': {
      display: 'none',
    }
  },
  learnpages: {
    "& .res-box": {},
    "& .videos-box-res": {
      position: "unset",
      right: "-80px",
      width: "130%",
      marginLeft: "25px",
      maxHeight: "825px",
      overflow: "auto",
      "@media(max-width:1280px)": {
        right: "-64px",
        width: "100%",
      },
      [theme.breakpoints.down("md")]: {
        right: theme.spacing(-6),
        
      },
      [theme.breakpoints.down("sm")]: {
        right: theme.spacing(0),
        position: "unset",
        marginLeft: "0",
        maxHeight: "none",
      },
    },
    "& .v-line":{
      borderRight: `1px solid ${alpha(Colors.black, 0.1)}`
    },
    "& .body-color": {
      color: Colors.darkSlate,
    },
    "& .body-color-grey": {
      color: Colors.greySlate,
    },
    "& .continue-button": {
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
      },
    },
    "& .twitter-button": {
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    "& .video-image": {
      marginTop: "15px",
      borderRadius: "4px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
        height: "auto",
      },
    },
    "& .border-box": {
      borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
        height: "auto",
      },
    },
    "& .chip-box": {
      background: "none",
      fontSize: theme.typography.h4.fontSize,
      color: Colors.greySlate,
      fontWeight: theme.typography.h4.fontWeight,
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.body1.fontSize,
      },
      "& > span": {
        overflow: "visible !important",
        whiteSpace: "break-spaces !important",
      }
    },
    "& .video-clip": {
      maxWidth: "915px",
      width: "98%",
      height: "auto",
      [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
        height: "auto",
      },
    },
    
    "& h3": {
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.body1.fontSize,
        "& span": {
          fontSize: theme.typography.body1.fontSize,
        },
      },
    },

    "& .m-bottom": {
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1),
      },
    },
    "& .expire-image": {
      [theme.breakpoints.down("sm")]: {
        verticalAlign: "middle",
      },
    },

    "& .border-right": {
      borderRight: `1px solid ${alpha(Colors.black, 0.1)}`,
      [theme.breakpoints.down("sm")]: {
        borderRight: 0,
        borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
      },
    },

    //QCM page
    "& .box-border-main": {
      border: `1px solid ${alpha(Colors.black, 0.1)}`,
      borderRadius: "8px",
    },
    "& .chip-text": {
      "& span": {
        color: Colors.green,
      },
    },
    "& .MuiSvgIcon-root": {
      width: "16px",
      height: "16px",
    },
    // learn result
    "& .box-shadow": {
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,
    },
    "& .accordion-box": {
      maxHeight: "320px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        maxHeight: "fit-content",
      },
    },
    "& .scroller": {
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {},
      "&::-webkit-scrollbar-thumb": {
        background: "#ECF0F3 ",
        border: `2px solid ${alpha(Colors.white, 1)}`,
      },
    },
    "& .prize-box": {
      position: "relative",
    },
    "& .prize-box:after": {
      content: "''",
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "-40px",
      width: "1px",
      background: alpha(Colors.black, 0.1),
      display: "inline-block",
      [theme.breakpoints.down("sm")]: {
        display: 'none'
      },
    },
    "& .img-align": {
      alignSelf: "start",
    },
    "& .learn-button": {
      paddingRight: "45px",
      paddingLeft: "45px",
      paddingTop: "10px",
      paddingBottom: "10px",
      "&:first-child": {
        marginRight: "32px",
      },
      [theme.breakpoints.down("sm")]: {
        paddingRight: "13px",
        paddingLeft: "14px",
        paddingTop: "9px",
        paddingBottom: "9px",
        width: "50%",
        "&:first-child": {
          marginRight: "11px",
        },
      },
    },

    "& h4": {
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.lineHeight,
        "& span": {
          lineHeight: theme.typography.body1.lineHeight,
        },
      },
    },
    "& .ml-img": {
      marginLeft: theme.spacing(3),
      [theme.breakpoints.down("sm")]: {
        marginLeft: theme.spacing(0),
        width: "20px",
        height: "auto",
        alignSelf: "baseline",
        marginTop: "2px"
      },
    },
    "& .text-br": {
      [theme.breakpoints.down("sm")]: {
        "& br": {
          display: "none",
        },
      },
    },
    
    //radio button

    // suode
    "& suode-box": {
      "&::before": {
        content: "hello",
        display: "inline-block",
        borderLeft: "1px solid black",
      },
    },
    "& .back-btn":{
      "& .MuiButton-label":{
        fontSize:"12px"
      },
      "& .MuiButton-startIcon":{
        marginRight:"4px"
      }
   },
  },
}));

export default useStyles;
